<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="400px">
    <div class="fill-height">


      <v-card class="fill-height">


        <v-card-title class="p-1 ">
          <v-chip
              label small
              class="ma-2"
              color="secondary"
          >
              ویرایش تنظیمات هشدار شارژ
            DF-09-02
          </v-chip>
          <v-spacer/>
          <v-btn light icon @click.stop="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-spacer/>
        <v-card-text>

          <v-form ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col
                  cols="12"
                  sm="12"
                  md="12">
                <v-autocomplete
                    :items="buildingList"
                    @change="onChangeBuilding"
                    v-model="model.buildingId"
                    label="انتخاب مجتمع"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('buildingId')"
                />
              </v-col>
              <v-col
                  cols="12"
                  md="12"
                  sm="12">
                <v-text-field
                    dense
                    label=" حداقل اعتبار پیامکی"
                    outlined
                    type="number"
                    v-model="model.minSmsCredit"
                    :error-messages="getError('minSmsCredit')">
                </v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  md="12">
                <v-autocomplete
                    :items="userList"
                    multiple
                    v-model="model.userIds"
                    label="انتخاب کاربران"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('userIds')"
                >

                  <template v-slot:selection="{ item, index }">
                    <!--                    <v-chip v-if="index === 0">-->
                    <span v-if="index === 0" >{{ item.text }}</span>
                    <!--                    </v-chip>-->
                    <span
                        v-if="index === 1"
                        class="grey--text caption"
                    >
          (+{{ model.userIds.length - 1 }} دیگر)
        </span>
                  </template>

                </v-autocomplete>
              </v-col>

             </v-row>

            <v-divider/>
            <v-card-actions>

              <v-btn
                  color="primary"
                  class=" pr-10 pl-10"
                  type="submit"
                  block
              >
                ذخیره
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Service from "./Service";

export default {
  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
    buildingList:Array,
    userList:Array,

  },
  data() {
    return {
      bindingErrors: [],
      valid: true,
    }
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors = []
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('ChargingAlarmSetting')

    },
    onChangeBuilding(val){
      Service.getUsers(val).then(response=>{
        this.userList=response.data.userList
      })
    },
    save() {
      this.bindingErrors = []
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        Service.save(this.model).then(response => {
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.closed()
          } else if (response && response.response.status === 400) {
            this.bindingErrors = response.response.data;
          }
        })
      }
    },

  },


}
</script>


